import { path } from 'ramda';
import { getSelectedKey } from './getSelectedKey';

export function getIsCollapseEnabled(state, appKey) {
	return path(
		['ui', 'byKey', getSelectedKey(state), 'selectedCollapses', appKey],
		state,
	);
}
